import { Flow } from '@/interfaces/requirement';
import { RequirementService } from '@/services/requirement/requirement.service';
import { StoreState } from '@/store';
import { AddNewTooltip, HideTooltip, RemoveTooltip } from '@/store/flow-states-tooltip/actions';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Person } from '../../interfaces/person/index';

@Component({
  selector: 'app-flow-states[id]',
  templateUrl: './flow-states.component.html',
  styleUrls: ['./flow-states.component.css'],
})
export class FlowStatesComponent implements OnInit, OnDestroy {

  @Input() withDate: boolean = true;
  @Input() centered: boolean = true;
  @Input() id: number = 0;
  @Input() variant: 'full' | 'tiny' = 'full';

  @Input() get requirementStatus(): Flow[] {
    return this._requirementStatus;
  }
  set requirementStatus(flow: Flow[]) {
    this._requirementStatus = flow;

    setTimeout(() => {
      const containerNode = this.containerRef.nativeElement;
      containerNode.scrollLeft = containerNode.scrollWidth;
      this.visible = true;
    }, 0);
  }

  _requirementStatus!: Flow[];

  visible: boolean = false;

  @ViewChild('container', { static: false }) containerRef: ElementRef;

  personData: Partial<Person> = {};

  @Output() dataLoaded = new EventEmitter<boolean>();

  constructor(
    private requirementService: RequirementService,
    private ref: ElementRef,
    private store: Store<StoreState>,
  ) {
    this.containerRef = this.ref;
  }

  ngOnInit(): void {
    if (!this.requirementStatus) {
      this.requirementService.getFlow(this.id).subscribe({
        next: (flowSteps) => {
          this.requirementStatus = flowSteps;
          this.dataLoaded.emit(true);
        },
      });
    }
  }

  onHover(e: Event, step: Flow) {
    const node = e.target as HTMLLIElement;
    const position = this.getOffset(node);

    let text = '';
    if (step.delegator && step.name.includes('Delegado')) {
      text = `${step.delegator} lo delego a ${step.assigned}`;
    }
    else if (step.delegator && step.name.includes('Antecedentes')) {
      text = `${step.delegator} lo solicitó a ${step.assigned}`;
    }
    else {
      text = step.assigned || step.roleName;
    }


    this.store.dispatch(AddNewTooltip({
      id: step.id,
      positionX: position.x,
      positionY: position.y,
      message: text,
      show: true,
    }));
  }

  onLeaving(e: Event, step: Flow) {
    this.store.dispatch(HideTooltip({
      id: step.id,
    }));
  }

  getOffset(el: HTMLLIElement) {
    const rect = el.getBoundingClientRect();
    return {
      x: rect.left + window.scrollX + (el.offsetWidth / 2) - 10,
      y: rect.top + window.scrollY + (el.offsetHeight / 2),
    };
  }

  ngOnDestroy() {
    this._requirementStatus.map((step)=> {
      this.store.dispatch(RemoveTooltip({
        id: step.id,
      }));
    });
  }

}
